import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import CreateTrip from "../components/CreateTrip";

const CreateTripPage = () => {
  const navigate = useNavigate();

  return (
	<Layout>
	  <div className="bg-background min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 py-8">
		<div className="w-full max-w-md bg-white shadow-md rounded-lg p-6 sm:p-8">
		  <h1 className="text-xl sm:text-2xl font-bold text-primary mb-4">Plan New Trip</h1>
		  <CreateTrip />
		  <button
			onClick={() => navigate("/dashboard")}
			className="mt-4 w-full sm:w-auto bg-secondary text-white px-4 py-2 rounded-lg hover:bg-green-600"
		  >
			Back
		  </button>
		</div>
	  </div>
	</Layout>
  );
};

export default CreateTripPage;
